import React, { Component } from 'react';
import ProfileBanner from 'components/ProfileBanner';
import GetUserDetails from 'components/GetUserDetails';
import Session from 'components/Session';
import Footer from 'components/Footer';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './Parent.scss';// to import local scss fle


class Profile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  render() {
    return (
      <div className={cn('row', styles.profileContainer)}>
        <ProfileBanner />
        <GetUserDetails {...this.props} usedFor="parent" />
        <Footer />
      </div>
    );
  }
}

export default Session(Profile);



// WEBPACK FOOTER //
// ./src/containers/RegisterParent/Parent.js